export const getters = {
    filterByName: (state) => {
        return (name) => {
            if (state.config.filters) {
                let selectedFilter = state.config.filters.find(filter => {
                    return filter.name === name
                });

                if (selectedFilter) {
                    return selectedFilter;
                }
                if (state.config.morefilters) {
                    selectedFilter = state.config.morefilters.find(filter => {
                        return filter.name === name
                    });
                    return selectedFilter;
                }
            }
            return null;
        }
    },
    filterValueByName: (state) => (filterName) => {
        if (state.selectedFilterValues[filterName]) {
            return state.selectedFilterValues[filterName];
        }
        else {
            return null;
        }
    }
};
